<script>
import ListDefault from "../Utils/Page/ListDefault";

export default {
    name: "EmailSubscriptionsList",
    mixins: [ListDefault],
    data() {
        return {
            isVisibleCreateButton: false,
            isVisibleEditButton: false,
            isVisibleDeleteButton: false,
            lang: this.$ml.get('pages.email_subscriptions'),

            filter: {
                email: {value: null, type: 'text'},
                type: {
                    value: null, type: 'select', options: []
                },
                decluttering_and_downsizing: {
                    value: null,
                    type: 'select',
                    options: [
                        {id: false, title: this.$ml.get('interface.no')},
                        {id: true, title: this.$ml.get('interface.yes')},
                    ]
                },
                estate_planning: {
                    value: null,
                    type: 'select',
                    options: [
                        {id: false, title: this.$ml.get('interface.no')},
                        {id: true, title: this.$ml.get('interface.yes')},
                    ]
                },
                geneaology_and_family_history: {
                    value: null,
                    type: 'select',
                    options: [
                        {id: false, title: this.$ml.get('interface.no')},
                        {id: true, title: this.$ml.get('interface.yes')},
                    ]
                },
                insurance: {
                    value: null,
                    type: 'select',
                    options: [
                        {id: false, title: this.$ml.get('interface.no')},
                        {id: true, title: this.$ml.get('interface.yes')},
                    ]
                },
                tips_and_tricks: {
                    value: null,
                    type: 'select',
                    options: [
                        {id: false, title: this.$ml.get('interface.no')},
                        {id: true, title: this.$ml.get('interface.yes')},
                    ]
                },
            },

            tableHeader: [
                {key: 'id', is_sort: true},
                {key: 'email', is_sort: true, classes: 'text-l'},
                {key: 'type', is_sort: false, classes: 'text-l'},

                {key: 'decluttering_and_downsizing', is_sort: false, classes: 'text-l'},
                {key: 'estate_planning', is_sort: false, classes: 'text-l'},
                {key: 'geneaology_and_family_history', is_sort: false, classes: 'text-l'},
                {key: 'insurance', is_sort: false, classes: 'text-l'},
                {key: 'tips_and_tricks', is_sort: false, classes: 'text-l'},

                {key: 'created_at', is_sort: true, classes: 'text-l'},
            ],
            tableHeaderAppend: [],

            tableBody: {
                created_at: {type: 'function', function: this.getDate},
                decluttering_and_downsizing: {type: 'boolean'},
                estate_planning: {type: 'boolean'},
                geneaology_and_family_history: {type: 'boolean'},
                insurance: {type: 'boolean'},
                tips_and_tricks: {type: 'boolean'},
            },

            apiList: this.$store.getters.getApiUrl('email_subscriptions'),
            pageRoute: 'email_subscriptions_list',
            pageRouteCreate: 'email_subscriptions_list.create',
            pageRouteEdit: 'email_subscriptions_list.edit',

            selectBooleanOptions: [
                { id: null, title: '' },
                { id: false, title: this.$ml.get('interface.no') },
                { id: true, title: this.$ml.get('interface.yes') },
            ],
        }
    },

    methods: {
        getDate(item) {
            if (!item.created_at) {
                return null
            }
            let date = new Date(Date.parse(item.created_at))
            return date.toISOString().slice(0, 19).replace('T', ' ')
        },
        getYesNoValue(item, key) {
            console.log('item', item)
            console.log('key', key)
        }
    },

    mounted() {
        this.getDictionaries().then(({data}) => {
            this.dictionaries = data.dictionaries

            for (let key in this.filter) {
                if (this.dictionaries[key]) {
                    this.filter[key].options = this.dictionaries[key]
                }
            }
        })
    }
}
</script>
